<template>
  <ion-page class="ppt-dynamic-preview-page">
    <ion-header class="ion-no-border">
      <div class="toolbar flex-row align-center">
        <button class="toolbar-btn toolbar-btn--back" type="button" @click="onClose">
          <img class="nav-back" :src="getBrandImageUrl('ai_smart_reading/nav_back.png')" alt="" />
          <span>返回</span>
        </button>

        <div class="toolbar-title" :title="fileName || 'PPT 预览'">
          {{ fileName || "PPT 预览" }}
        </div>

        <div class="toolbar-meta"></div>
      </div>
    </ion-header>

    <ion-content class="stage-content" :scroll-y="false" :fullscreen="false">
      <div class="stage">
        <div v-if="loading" class="loading-container loading-container--overlay">
          <ion-spinner name="circles"></ion-spinner>
          <p>课件加载中...</p>
        </div>

        <iframe
          v-if="previewUrl"
          class="ppt-iframe"
          :class="{ 'is-ready': !loading }"
          :src="previewUrl"
          frameborder="0"
          allowfullscreen
          @load="onIframeLoad"
        ></iframe>

        <div v-else-if="!loading" class="preview-empty">暂无预览内容</div>

        <DrawingBoard
          v-if="!loading && previewUrl"
          ref="drawingBoardRef"
          :enabled="drawingEnabled"
          default-mode="none"
          :default-color="drawingColor"
          :pen-width="6"
          :eraser-width="36"
        />
      </div>
    </ion-content>
  </ion-page>
</template>

<script>
import { IonPage, IonHeader, IonContent, IonSpinner, modalController } from "@ionic/vue"
import { getBrandImageUrl } from "@/js/brandImages.ts"
import DrawingBoard from "@/components/DrawingBoard.vue"
import store from "@/js/store.ts"

/**
 * 动态 PPT 预览：与 admin DynamicPptPreviewDialog 一致
 * previewUrl = (OEMBASE + fileHtml).replace('/oem', '')
 */
export default {
  name: "PptDynamicPreview",
  components: {
    IonPage,
    IonHeader,
    IonContent,
    IonSpinner,
    DrawingBoard,
  },
  props: {
    fileName: {
      type: String,
      default: "PPT 预览",
    },
    fileHtml: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      loading: false,
      previewUrl: "",
      drawingEnabled: true,
      drawingColor: "#E53935",
    }
  },
  mounted() {
    window.addEventListener("keydown", this.handleKeydown)
    this.initPreview()
  },
  beforeUnmount() {
    window.removeEventListener("keydown", this.handleKeydown)
  },
  methods: {
    getBrandImageUrl,
    onClose() {
      modalController.dismiss()
    },

    initPreview() {
      if (!this.fileHtml) {
        console.warn("[PptDynamicPreview] 课件地址为空")
        this.loading = false
        this.previewUrl = ""
        return
      }
      this.loading = true
      // 与 admin 一致：OEMBASE + fileHtml，去掉 /oem
      this.previewUrl = ((store.getOEMBASE() || "") + this.fileHtml).replace("/oem", "")
      console.log("[PptDynamicPreview] previewUrl:", this.previewUrl)
    },

    onIframeLoad() {
      this.loading = false
    },

    handleKeydown(event) {
      if (event.key === "Escape") {
        event.preventDefault()
        this.onClose()
      }
    },
  },
}
</script>

<style scoped lang="less">
@import "@/assets/common.less";

.ppt-dynamic-preview-page {
  width: 100%;
  height: 100%;
  background: #eef2f6;

  .toolbar {
    width: 100%;
    height: 52px;
    padding: 0 16px;
    box-sizing: border-box;
    background: #ffffff;
    border-bottom: 1px solid #e4e7ed;
    gap: 16px;

    .toolbar-btn {
      display: inline-flex;
      align-items: center;
      gap: 8px;
      height: 36px;
      padding: 0 14px;
      border: 1px solid #dcdfe6;
      border-radius: 8px;
      background: #f5f7fa;
      color: #303133;
      font-size: 14px;
      font-weight: 500;
      cursor: pointer;
      flex-shrink: 0;
      transition: background 0.15s ease;

      .nav-back {
        width: 7px;
        height: 12px;
        opacity: 0.85;
      }

      &:hover,
      &:active {
        background: #ebf0f5;
      }
    }

    .toolbar-title {
      flex: 1;
      min-width: 0;
      text-align: center;
      font-size: 16px;
      font-weight: 600;
      color: #303133;
      letter-spacing: 0.02em;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .toolbar-meta {
      min-width: 88px;
      flex-shrink: 0;
    }
  }
}

.stage-content {
  --background: #eef2f6;
  position: relative;
  height: 100%;
}

.stage-content::part(scroll) {
  position: relative;
  display: flex;
  flex-direction: column;
  height: 100%;
}

.loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  gap: 14px;
  color: #606266;
  font-size: 15px;
}

.loading-container--overlay {
  position: absolute;
  inset: 0;
  z-index: 20;
  background: #eef2f6;
}

.stage {
  position: absolute;
  inset: 0;
  overflow: hidden;
  background: #eef2f6;
}

.ppt-iframe {
  display: block;
  width: 100%;
  height: 100%;
  border: 0;
  background: #fff;
  opacity: 0;
  transition: opacity 0.2s ease;
}

.ppt-iframe.is-ready {
  opacity: 1;
}

.preview-empty {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  color: #909399;
  font-size: 15px;
}
</style>
